import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Copyright from '../modules/dashboard/internals/components/Copyright';
import ChartLoansByBranch from './ChartLoansByBranch';
import CustomizedTreeView from './CustomizedTreeView';
import PaymentsDataGrid from './PaymentsDataGrid';
import SummaryCard from './SummaryCard';
import PageViewsBarChart from './PageViewsBarChart';
import SessionsChart from './SessionsChart';
import StatCard from './StatCard';
import useDashboard from '../hooks/useDashboard';

export default function MainGrid() {
  const { dashboardData, summaryData, branchData, todaysPayments, loading, error, refreshData } = useDashboard();

  if (loading) {
    return (
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ ml: 2 }}>
          Cargando datos del dashboard...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {error}. Mostrando datos de ejemplo.
        </Alert>
      </Box>
    );
  }
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Descripción General
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {dashboardData.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <SummaryCard summaryData={summaryData} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ChartLoansByBranch branchData={branchData} />
        </Grid>
      </Grid>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Detalles
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }}>
          <PaymentsDataGrid 
            todaysPayments={todaysPayments} 
            loading={loading} 
            error={error} 
          />
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
